import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  const isFree = Number(product.price) === 0;
  const isComingSoon = Boolean(product.coming_soon);
  const priceLabel = isFree ? "FREE" : (Number.isInteger(product.price) ? `$${product.price}` : `$${product.price.toFixed(2)}`);

  const detailPath = `/product/${product.slug || product.id}`;

  const button = isComingSoon ? (
    <span
      data-testid={`product-coming-soon-${product.id}`}
      aria-disabled="true"
      className="inline-flex items-center gap-2 px-6 py-3 text-[0.7rem] tracking-[0.28em] uppercase cursor-not-allowed select-none"
      style={{
        background: "var(--opus-gray-light)",
        color: "var(--opus-text-muted)",
        borderRadius: "2px",
      }}
    >
      Coming soon
    </span>
  ) : (
    <Link
      to={detailPath}
      data-testid={`product-get-it-${product.id}`}
      className="btn-sage inline-flex items-center gap-2 px-6 py-3 text-[0.7rem] tracking-[0.28em] uppercase"
      style={{ borderRadius: "2px" }}
    >
      See details ↗
    </Link>
  );

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className={`opus-card relative flex flex-col p-9 md:p-10 h-full ${isComingSoon ? "pointer-events-none" : ""}`}
      style={{
        minHeight: "380px",
        opacity: isComingSoon ? 0.85 : 1,
      }}
    >
      <span
        data-testid={`product-price-badge-${product.id}`}
        className={isFree ? "absolute top-7 right-9 font-body" : "absolute top-7 right-9 font-display"}
        style={isFree
          ? { color: "var(--opus-sage)", fontSize: "0.75rem", fontWeight: 600, letterSpacing: "0.28em", textTransform: "uppercase" }
          : { color: "var(--opus-sage)", fontSize: "1.6rem", fontWeight: 500, letterSpacing: "0.01em" }
        }
      >
        {priceLabel}
      </span>

      <h3
        data-testid={`product-title-${product.id}`}
        className="font-display leading-[1.1] pr-20"
        style={{
          color: "var(--opus-text)",
          fontSize: "clamp(1.55rem, 2.3vw, 1.95rem)",
          fontWeight: 500,
        }}
      >
        {product.title}
      </h3>

      <p
        data-testid={`product-desc-${product.id}`}
        className="font-body leading-relaxed mt-6 flex-1"
        style={{ color: "var(--opus-text-secondary)", fontSize: "0.98rem" }}
      >
        {product.short_description}
      </p>

      <div className="mt-8 pt-6 border-t flex items-center justify-end" style={{ borderColor: "var(--opus-border)" }}>
        {button}
      </div>
    </article>
  );
}
